import { BiometryType } from "@aparajita/capacitor-biometric-auth";
import { Capacitor } from "@capacitor/core";

export const getBiometricLabel = (value: BiometryType) => {
  if (
    [
      BiometryType.faceAuthentication,
      BiometryType.faceId,
      BiometryType.irisAuthentication,
    ].includes(value)
  ) {
    return Capacitor.getPlatform() === "android" ? "Biometrics" : "Face ID";
  } else if ([BiometryType.fingerprintAuthentication, BiometryType.touchId].includes(value)) {
    return Capacitor.getPlatform() === "android" ? "Biometrics" : "Touch ID";
  }

  return "";
};
